import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { toast } from "sonner";
import { Save, Mail, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Settings() {
  const [me, setMe] = useState(null);
  const [notifyEmail, setNotifyEmail] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      setMe(r.data);
      setNotifyEmail(r.data.notification_email || r.data.email || "");
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!notifyEmail.trim()) { toast.error("Enter an email"); return; }
    setSaving(true);
    try {
      await api.put("/auth/me/notification-email", { notification_email: notifyEmail.trim() });
      toast.success("Notification email saved");
      setMe((prev) => (prev ? { ...prev, notification_email: notifyEmail.trim() } : prev));
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to save");
    }
    setSaving(false);
  };

  return (
    <div className="min-h-screen bg-stone-100">
      <Navbar />
      <div className="max-w-3xl mx-auto p-6">
        <Link to="/dashboard" className="text-sm text-stone-600 hover:underline inline-flex items-center gap-1 mb-4" data-testid="back-to-dashboard">
          <ArrowLeft className="w-3 h-3"/> Dashboard
        </Link>
        <h1 className="font-heading font-black text-3xl mb-2">Settings</h1>
        <p className="text-sm text-stone-600 mb-6">Where CanvasKit sends new-order alerts.</p>

        <form onSubmit={save} className="brutal-card p-6 space-y-4" data-testid="settings-form">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-stone-600">
            <Mail className="w-4 h-4"/> Order-notification email
          </div>
          <input
            type="email"
            required
            className="brutal-input w-full"
            value={notifyEmail}
            onChange={(e) => setNotifyEmail(e.target.value)}
            placeholder="you@yourshop.com"
            data-testid="notification-email-input"
          />
          <p className="text-xs text-stone-500">
            Every new customer order triggers an alert to this address (with the customer&apos;s
            name, WhatsApp, SKU, template, order reference, and a direct link to the hi-res preview).
            Defaults to your login email — change it here anytime.
          </p>
          <button
            type="submit"
            disabled={saving}
            className="brutal-btn bg-green-200 px-4 py-2 rounded-md text-sm flex items-center gap-1"
            data-testid="save-settings-btn"
          >
            <Save className="w-4 h-4"/> {saving ? "Saving…" : "Save"}
          </button>

          {me && (
            <div className="pt-4 border-t border-stone-300 text-xs text-stone-600">
              Signed in as <b>{me.email}</b> · Role: <b>{me.role}</b>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
